import { gql } from '@apollo/client/core/index.js';
export const typeDefs = gql `
  input Context {
    country: String!
    language: String!
    audience: Audience
  }

  enum Audience {
    INTERMEDIARY
    INSTITUTIONAL
    CORPORATE
    INDIVIDUAL_INVESTOR
    RPS
  }

  input DataRequest {
    context: Context!
    type: String!
  }

  type DataResponse {
    type: String!
  }

  input HistoricalDatesInput {
    topTenHoldings: [String!]!
    fullHoldings: [String!]!
  }

  input ProductRequest {
    productCode: String!
    historicalDates: HistoricalDatesInput
  }

  ########################################################################################################################
  #
  #   PRODUCT DATA
  #
  ########################################################################################################################
  type Query {
    fetchData(req: DataRequest): DataResponse
    disclaimer: [PclDisclaimer]
  }

  # Metadata
  type ProductMetadata {
    portfolioSymbolCode: ID!
    portfolioName: String!
    parentFundCode: String
    baseISOCurrencyCode: String
    parentBaseISOCurrencyCode: String
    perfInceptionDate: String
    investmentProductsName60Char: String
    portfolioTypeCode: String
    portfolioTypeName: String
    monthlyPerformanceEffectiveDate: String
    assetTypeName: String
    reportingPortfolioShareClassName: String
    productClassName: String
    strategyName: String
    isin: String
    shareClassInceptionDate: String
    shareClassAmount: BigDecimal
    shareClassCusip: String
    baseISOCurrencyName: String
    shareClassApirCode: String
    shareClassWknNumber: String
    shareClassValorNumber: String
    shareClassBloombergId: String
    sfdrClassification: String
    registeredCountries: [String]
  }

  extend input DataRequest {
    productRequest: ProductRequest
  }

  extend type DataResponse {
    metadata: ProductMetadata
  }

  # Disclaimers
  extend type ExhibitDisclaimer {
    code: ID!
    text: String!
    rank: String
    superscriptPosition: String
    footer: Boolean
    benchmarks: String
    currencies: [String]
    peerUniverse: Boolean
    greyBackground: Boolean
  }

  extend type DataResponse {
    topTenHoldingsExhibit: TopTenHoldingsExhibit
  }

  type TopTenHoldingsExhibit {
    id: ID!
    title: String!
    totalTopTenTNA: Float
    totalTopTenTFE: String
    effectiveDate: String
    availablePriorDates: [String]
    holdings: [Holding]
    disclaimers: [ExhibitDisclaimer]
    vehicle: String
    assetClass: String
    issuerGuarantorTypeName: String
    databaseEntryCreated: String
    spectrum: Boolean
  }

  type Holding {
    name: String
    typeName: String
    sectorName: String
    industryName: String
    countryName: String
    rankNumber: Int
    tnaPercentage: Float
  }
`;
//# sourceMappingURL=schema.js.map